module.exports = __webpack_public_path__ + "img/plus-blancTransparent.a44672f.png";